import { CardCursoComplementar as Card } from './components/card/card.component';
import { ContainerLista as Container } from './components/container-lista/container-lista.component';

const ListaCursosComplementares = {
  Container,
  Card,
};

export { ListaCursosComplementares };
